// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","imageContent":"JAf8H","formatRectangle":"_1MWyj","imageDesktop":"_2QqR2","imageTablet":"_3KyII","imageMobile":"_2HPew"};